export const BUCKET_OBJECTS_SORT = 'BUCKET_OBJECTS_SORT';
export function actionSort({ type }) {
    return {
        type: BUCKET_OBJECTS_SORT,
        data: { type },
    };
}
